// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: WVm1zuxFAu

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicAttentionIndicator.module.css"; // plasmic-import: WVm1zuxFAu/css

createPlasmicElementProxy;

export type PlasmicAttentionIndicator__VariantMembers = {
  level: "_4" | "_3" | "_2" | "_1" | "_0";
};
export type PlasmicAttentionIndicator__VariantsArgs = {
  level?: SingleChoiceArg<"_4" | "_3" | "_2" | "_1" | "_0">;
};
type VariantPropType = keyof PlasmicAttentionIndicator__VariantsArgs;
export const PlasmicAttentionIndicator__VariantProps =
  new Array<VariantPropType>("level");

export type PlasmicAttentionIndicator__ArgsType = {};
type ArgPropType = keyof PlasmicAttentionIndicator__ArgsType;
export const PlasmicAttentionIndicator__ArgProps = new Array<ArgPropType>();

export type PlasmicAttentionIndicator__OverridesType = {
  root?: p.Flex<"div">;
  freeBox?: p.Flex<"div">;
};

export interface DefaultAttentionIndicatorProps {
  level?: SingleChoiceArg<"_4" | "_3" | "_2" | "_1" | "_0">;
  className?: string;
}

const $$ = {};

function PlasmicAttentionIndicator__RenderFunc(props: {
  variants: PlasmicAttentionIndicator__VariantsArgs;
  args: PlasmicAttentionIndicator__ArgsType;
  overrides: PlasmicAttentionIndicator__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "level",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.level
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [sty.rootlevel__0]: hasVariant($state, "level", "_0"),
          [sty.rootlevel__1]: hasVariant($state, "level", "_1"),
          [sty.rootlevel__2]: hasVariant($state, "level", "_2"),
          [sty.rootlevel__3]: hasVariant($state, "level", "_3"),
          [sty.rootlevel__4]: hasVariant($state, "level", "_4")
        }
      )}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox)}
      />
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox"],
  freeBox: ["freeBox"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicAttentionIndicator__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicAttentionIndicator__VariantsArgs;
    args?: PlasmicAttentionIndicator__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicAttentionIndicator__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicAttentionIndicator__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAttentionIndicator__ArgProps,
          internalVariantPropNames: PlasmicAttentionIndicator__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAttentionIndicator__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAttentionIndicator";
  } else {
    func.displayName = `PlasmicAttentionIndicator.${nodeName}`;
  }
  return func;
}

export const PlasmicAttentionIndicator = Object.assign(
  // Top-level PlasmicAttentionIndicator renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicAttentionIndicator
    internalVariantProps: PlasmicAttentionIndicator__VariantProps,
    internalArgProps: PlasmicAttentionIndicator__ArgProps
  }
);

export default PlasmicAttentionIndicator;
/* prettier-ignore-end */
